<template>
  <div class="fankui">
    <div class="content">
      <div class="questionTitle">问题类型</div>
      <div class="questionType">
        <ul>
          <li
            v-for="(item, index) in typeList"
            :key="index"
            @click="change(index)"
            :class="{ active: index == current }"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="miaosu">
        <div class="miaosuTitle">
          问题和意见 <span class="bitian">(必填)</span>
        </div>
        <div class="contentArea">
          <textarea
            id="a"
            v-model="text"
            maxlength="150"
            @input="limitLength"
            placeholder="请简要描述您的问题和意见，上传相关页面能够帮助我们更快速解决问题呢～"
          ></textarea>
          <div class="wordLimit">{{ areaLength }}/150</div>
        </div>
      </div>
      <div class="shangchuan">
        <div class="shangchuanTitle">
          上传图片 <span class="shangchuan">(最多6张)</span>
        </div>
        <div class="sendPic">
          <van-uploader
            :after-read="afterRead"
            v-model="fileList"
            :max-count="6"
            @delete="delImg"
          />
        </div>
      </div>
    </div>
    <div class="dibuBtn">
      <button @click="submit">提交</button>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import { Uploader } from "vant";
import Vue from "vue";
import qs from "qs";
import { Toast } from "vant";
Vue.use(Toast);

Vue.use(Uploader);
import { Dialog } from "vant";
export default {
  mounted() {

    this.getMobileInfo();
  },
  data() {
    return {
      typeList: ["账号登录", "信息收发", "产品使用", "关于活动", "其他"],
      current: 0,
      areaLength: 0,
      text: "",
      fileList: [],
      fileurlList: [],
      file: [],
      mobileOsType: "",
      upLoading: false,
    };
  },
  methods: {
    delImg(file, detail) {
      console.log(this.fileurlList);

      let params = qs.stringify({
        picturePath: this.fileurlList[detail.index],
      });
      console.log(this.fileurlList[detail.index]);
      this.$axios
        .post("appinteraction/appInteraction/delImg", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            this.$toast("删除失败");
          }
          if (res.data.result === 1) {
            this.fileurlList.splice(detail.index, 1);
            this.$toast("删除成功");
            console.log(this.fileurlList);
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },

    change(index) {
      this.current = index;
    },
    limitLength() {
      this.areaLength = this.text.length;
    },
    async afterRead(file, detail) {
      let f = file.file;
      console.log(f);
      if (f.size > 10485760) {
        Dialog.alert({
          message: "图片大小超过10M，请选择10M以内图片上传",
        }).then(() => {
          this.fileList.splice(detail.index, 1);
        });
        return;
      }
      if (f.type == "image/gif") {
        Dialog.alert({
          message: "不支持GIF类型图片，请选择正确类型的图片上传",
        }).then(() => {
          this.fileList.splice(detail.index, 1);
        });
        return;
      }
      let formdata = new FormData();

      formdata.append("fileList", f);

      Toast.loading({
        message: "图片上传中...",
        forbidClick: true,
      });
      this.$axios
        .post("/appinteraction/appInteraction/uploadImg",formdata, {
          headers: {
            "Content-Type":
              "multipart/form-data; boundary = " + new Date().getTime(),
          },
        })
        .then((res) => {
  
          if (res.data.result !== 1) {
             Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            this.fileurlList.push(res.data.fileurlList[0]);
            console.log(this.fileurlList);

            Toast.success("图片上传成功");
          }
        })
        .catch((err) => {
          Toast.clear();
          console.log(err);
          alert(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
        });
    },

    submit() {
      if (this.fileList.length == 0) {
        Dialog.alert({
          message: "上传图片不能为空",
        }).then(() => {});
        return;
      }

      if (this.text == "") {
        Dialog.alert({
          message: "描述问题不能为空",
        }).then(() => {});
        return;
      }
      Toast.loading({
        message: "数据上传中...",
        forbidClick: true,
      });

      let params = qs.stringify({
        comeFrom: "鹿路通",
        fileurlList: this.fileurlList.join(","),
        problemType: this.current,
        productVersion: this.$route.query.version,
        phoneSystem: this.mobileOsType,
        productDescribe: this.text,
        diagnosisLog: "",
      });

      this.$axios
        .post("/appinteraction/user/userOpinion/saveUserOpinion", params)
        .then((res) => {
        
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            this.fileList = [];
            this.text = "";

            return;
          }

          if (res.data.result === 1) {
            Toast.clear();
            Dialog.alert({
              message: "提交成功",
            }).then(() => {
              this.$router.push("/FankuiTips");
              this.fileList = [];
              this.text = "";
            });

            return;
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },

    getMobileInfo() {
      var MobileDetect = require("mobile-detect");
      var md = new MobileDetect(navigator.userAgent);
      this.mobileOsType = md.os();
      console.log(this.mobileOsType);
    },
  },
};
</script>

<style lang="scss" scoped>
.fankui {
  background-color: #eef4f6;
  padding: 2.625rem 2rem 2rem 2rem;
  min-height: 100vh;
}
.content {
  background-color: #fff;
  padding: 0 2.25rem 0 2.25rem;
  border-radius: 1rem;
  .questionTitle {
    color: #19212a;
    font-size: 2rem;
    padding-top: 2rem;
    font-weight: 500;
  }
  .questionType {
    padding: 1.75rem 0 2.875rem 0;
    ul {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      border-bottom: 1px solid #eaeaea;

      li {
        width: 29%;
        margin-right: 4%;
        padding: 1.5rem 1.875rem 1.375rem 2rem;
        text-align: center;
        white-space: nowrap;
        border: 1px solid #eaeaea;
        border-radius: 1rem;
        color: #19212a;
        font-size: 1.875rem;
        margin-bottom: 1.75rem;
      }
      .active {
        background: rgba(190, 255, 255, 0.3);
        color: #338989;
        font-weight: bold;
        border: 1px solid #338989;
      }
    }
  }
  .miaosu {
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #eaeaea;
    .miaosuTitle {
      color: #19212a;
      font-size: 2rem;
      font-weight: 500;
      span {
        color: #878787;
        font-size: 1.75rem;
      }
    }
    .contentArea {
      margin-top: 1.75rem;
      background-color: #ffffff;

      #a {
        width: 100%;
        height: 13.375rem;
        border: none;
        font-size: 1.875rem;
        color: #878787;
      }
      .wordLimit {
        text-align: right;
        color: #878787;
        font-size: 1.5rem;
      }
    }
  }
  .shangchuan {
    padding: 1.75rem 0 3.375rem 0;
    .shangchuanTitle {
      color: #19212a;
      font-size: 2rem;
      font-weight: 500;
      span {
        color: #878787;
        font-size: 1.75rem;
      }
    }
    .sendPic {
      margin-top: 1.75rem;
    }
  }
}
.dibuBtn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.875rem;

  button {
    width: 100%;
    height: 5.5rem;
    background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
    border: none;
    color: #ffffff;
    font-size: 2rem;
    border-radius: 2.75rem;
    line-height: 5.5rem;
  }
}
.sendPic ::v-deep .van-uploader .van-uploader__upload {
  width: 11.5rem;
  height: 11.5rem;
  margin: 0;
  background-color: #fff;
  border: 1px dashed #eaeaea;
  border-radius: 1rem;
  background-image: url("../assets/images/shizijia.png");
  background-repeat: no-repeat;
  background-size: 4rem 4rem;
  background-position: 50% 50%;
  .van-icon {
    display: none;
  }
}
.sendPic ::v-deep .van-uploader .van-uploader__preview {
  margin: 0 1.25rem 1.5rem 0;
  .van-uploader__preview-image {
    width: 11.5rem;
    height: 11.5rem;
    img {
      width: 100%;
      height: 100%;
      border-radius: 1rem;
    }
  }
}
</style>